<mat-expansion-panel [expanded]="expanded" (opened)="onPanelOpen()" (closed)="onPanelClose()" class="m-b-10"
  style="box-shadow: none;">
  <mat-expansion-panel-header class="bg-light-primary m-b-10">
    <mat-panel-title>
      {{ (subcategory?.name || '') | translate }}
      <ng-container *ngIf="checkedCount > 0">
        <span class="m-l-5 f-s-14 f-w-500 text-muted">
          ({{ checkedCount }})
        </span>
      </ng-container>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container *ngIf="hasItems">
    <div class="m-b-10">
      <div class="checkbox-group">
        <div class="checkbox-item" *ngFor="let item of items">
          <div class="d-flex align-items-center gap-8 w-100 justify-content-between">
            <div class="d-flex align-items-center gap-8">
              <mat-checkbox color="primary" [(ngModel)]="item.isChecked" (ngModelChange)="onCheckboxChange(item)">
              </mat-checkbox>
              <span class="label-text">{{ item.description }}</span>
            </div>
            <div *ngIf="item.isSince && item.isChecked" style="width: 150px;">
              <mat-form-field appearance="outline" class="hide-hint w-100">
                <input type="text" matInput placeholder="Duration" [formControl]="getControl(item)"
                  [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event, item)">
                  <mat-option *ngFor="let option of getDurationOptions(item)" [value]="option">
                    {{ option }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!hasItems">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
      <h4 class="f-w-600">{{ 'LABEL.NO_DATA' | translate }}</h4>
      <!-- <h4 class="f-w-600 m-l-2">
        <a class="cursor-pointer" style="color: var(--mat-sys-primary);text-decoration: underline;"
          (click)="addClinicalItem($event)">
          {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}
        </a>
      </h4> -->
    </div>
  </ng-container>


</mat-expansion-panel>
